export const TRACKING_TOKENS_CURRENT_ENDPOINT = '/c/v1/tracking/tokens/current';
